import React from 'react';

import PortfolioGalleryCommon from '../../layouts-components__common-cases/portfolio-gallery';
import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonSmallTitle from '../../../common-components/common-small-title';
import CommonSmallText from '../../../common-components/common-small-text';

const imgList = [
    '/images/pic/rukami/gallery1.jpg',
    '/images/pic/rukami/gallery2.jpg',
    '/images/pic/rukami/gallery3.jpg',
    '/images/pic/rukami/gallery4.jpg',
    '/images/pic/rukami/gallery5.jpg',
    '/images/pic/rukami/gallery6.jpg',
    '/images/pic/rukami/gallery7.jpg',
    '/images/pic/rukami/gallery8.jpg',
    '/images/pic/rukami/gallery9.jpg',
    '/images/pic/rukami/gallery10.jpg',
    '/images/pic/rukami/gallery11.jpg',
    '/images/pic/rukami/gallery12.jpg',
    '/images/pic/rukami/gallery13.jpg',
    '/images/pic/rukami/gallery14.jpg',
    '/images/pic/rukami/gallery15.jpg',
    '/images/pic/rukami/gallery16.jpg',
    '/images/pic/rukami/gallery17.jpg',
    '/images/pic/rukami/gallery18.jpg',
    '/images/pic/rukami/gallery19.jpg',
    '/images/pic/rukami/gallery20.jpg',
    '/images/pic/rukami/gallery21.jpg',
    '/images/pic/rukami/gallery22.jpg',
    '/images/pic/rukami/gallery23.jpg',
    '/images/pic/rukami/gallery24.jpg',
    '/images/pic/rukami/gallery25.jpg',
    '/images/pic/rukami/gallery26.jpg',
    '/images/pic/rukami/gallery27.jpg',
    '/images/pic/rukami/gallery28.jpg',
    '/images/pic/rukami/gallery29.jpg',
    '/images/pic/rukami/gallery30.jpg',
    '/images/pic/rukami/gallery31.jpg',
    '/images/pic/rukami/gallery32.jpg',
    '/images/pic/rukami/gallery33.jpg',
    '/images/pic/rukami/gallery34.jpg',
    '/images/pic/rukami/gallery35.jpg',
    '/images/pic/rukami/gallery36.jpg',
    '/images/pic/rukami/gallery37.jpg',
    '/images/pic/rukami/gallery38.jpg',
    '/images/pic/rukami/gallery39.jpg',
    '/images/pic/rukami/gallery40.jpg',
    '/images/pic/rukami/gallery41.jpg',
    '/images/pic/rukami/gallery42.jpg',
    '/images/pic/rukami/gallery43.jpg',
    '/images/pic/rukami/gallery44.jpg',
];

const PortfolioGallery = () => {
    return (
        <ScrollAnimation animateIn="fadeIn" offset={50} animateOnce={true} duration={1}>
            <FullWrapper>
                <CommonSmallTitle>Дизайн</CommonSmallTitle>
                <CommonSmallText className="rukami-portfolio-gallery__paragraph">
                    Совместно с субподрядчиком наша команда проделала большую работу по разработке
                    нового дизайна фестиваля. Только для регистрации дизайнеры подготовили 11
                    макетов. Вебпрактик работал над внутренней частью платформы, а{' '}
                    <a
                        className="rukami-portfolio-gallery__link"
                        href="https://www.artlebedev.ru"
                        target="_blank"
                        rel="noopener noreferrer nofollow"
                    >
                        Студия Лебедева
                    </a>{' '}
                    отвечала за пользовательский дизайн.
                </CommonSmallText>
                <PortfolioGalleryCommon
                    imgList={imgList}
                    className="rukami-portfolio-gallery"
                    isMargin={true}
                    smallPaddings={true}
                />
                <CommonSmallText className="rukami-portfolio-gallery__paragraph">
                    Получилось две абсолютно разные концепции, которые предстояло подружить между
                    собой. В итоге систему навигации с публичной части внедрили во внутреннюю часть
                    платформы.
                </CommonSmallText>
                <CommonSmallText className="rukami-portfolio-gallery__paragraph">
                    Для защиты платформы от DDoS-атак и ради повышенной отказоустойчивости
                    микросервисы сайта были размещен в Yandex Cloud, файлы - в Yandex Object
                    Storage.
                </CommonSmallText>
            </FullWrapper>
        </ScrollAnimation>
    );
};

export default PortfolioGallery;
